import { render } from "./Footer.vue?vue&type=template&id=d014c090&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=d014c090&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d014c090"]])

export default __exports__